const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const absUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND}${u}`);
